var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogogetscreened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 173,
    viewBox: "0 0 560 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5221 73.2646C56.4071 80.5526 48.9721 86.7396 49.0001 87.0146C49.0641 87.6516 81.4711 113.396 82.5691 113.682C83.9451 114.041 88.3011 107.891 87.1821 107.17C83.5601 104.835 61.8881 87.5706 61.8881 87.0196C61.8881 86.6476 67.7361 81.7476 74.8831 76.1326L87.8791 65.9216L85.6951 62.9676C84.4941 61.3436 83.1931 60.0146 82.8041 60.0146C82.4141 60.0146 74.6381 65.9766 65.5221 73.2646Z",
    fill: "#A17C3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.695 61.7646C122.869 62.7266 121.88 64.0646 121.498 64.7376C121.051 65.5246 125.358 69.5656 133.596 76.0856C140.631 81.6546 146.494 86.5036 146.623 86.8626C146.753 87.2216 141.027 92.0146 133.901 97.5146C126.774 103.015 120.932 107.74 120.92 108.015C120.908 108.29 121.965 109.848 123.268 111.478L125.639 114.441L142.264 101.085C151.407 93.7386 158.888 87.3516 158.888 86.8896C158.888 86.0226 126.867 60.0146 125.799 60.0146C125.468 60.0146 124.522 60.8026 123.695 61.7646Z",
    fill: "#EBE394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.401 60.3586C106.582 63.1946 102.82 76.9126 99.0421 90.8436L92.1721 116.172L94.5951 117.094C98.5661 118.603 99.6801 118.183 100.764 114.765C102.526 109.215 115.888 59.3426 115.888 58.3186C115.888 57.7866 114.313 56.8666 112.389 56.2766L108.889 55.2026L107.401 60.3586Z",
    fill: "#EBE394"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.888 65.0476V68.0806L232.138 67.7976L243.388 67.5146L243.704 64.7646L244.021 62.0146H232.454H220.888V65.0476ZM231.888 66.0146C223.666 66.0146 221.888 65.7476 221.888 64.5146C221.888 63.2816 223.666 63.0146 231.888 63.0146C240.11 63.0146 241.888 63.2816 241.888 64.5146C241.888 65.7476 240.11 66.0146 231.888 66.0146Z",
    fill: "#EBE394"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.638 78.4986C222.125 79.8296 220.888 81.1796 220.888 81.4996C220.888 81.8186 225.951 81.9526 232.138 81.7976L243.388 81.5146L243.704 78.7646L244.021 76.0146L235.204 76.0466C227.326 76.0746 226.095 76.3356 223.638 78.4986ZM232.638 79.9826C224.286 79.9536 223.577 79.8086 225.329 78.4826C228.112 76.3776 241.888 76.4046 241.888 78.5146C241.888 79.7426 240.208 80.0086 232.638 79.9826Z",
    fill: "url(#paint0_linear_81_5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.888 65.0146V82.0146H250.888H253.888V68.0146V54.0146H259.388C264.832 54.0146 264.888 53.9846 264.888 51.0146V48.0146H256.388H247.888V65.0146ZM251.388 80.0146C250.119 80.0146 249.888 77.6256 249.888 64.5146V49.0146H256.888C262.444 49.0146 263.888 49.3246 263.888 50.5146C263.888 51.6666 262.61 52.0146 258.388 52.0146H252.888V66.0146C252.888 77.7926 252.65 80.0146 251.388 80.0146Z",
    fill: "url(#paint1_linear_81_5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.811 50.9376C269.679 54.0696 269.031 58.0386 270.959 62.2716C272.677 66.0416 275.885 67.4646 283.888 68.0066C291.148 68.4986 291.398 68.6016 291.7 71.2176C291.916 73.0896 291.378 74.3156 289.95 75.2076C287.799 76.5516 286.986 82.0146 288.938 82.0146C290.967 82.0146 295.84 78.9726 296.858 77.0696C298.897 73.2596 298.086 68.0586 294.965 64.9376C292.369 62.3416 291.355 62.0146 285.899 62.0146C282.521 62.0146 278.886 61.5486 277.822 60.9796C275.31 59.6346 275.345 56.3706 277.888 54.7826C279.103 54.0236 279.888 52.4506 279.888 50.7736C279.888 47.0116 276.662 47.0866 272.811 50.9376ZM274.136 63.7646C269.868 59.1916 270.693 52.9216 275.908 50.3136C279.083 48.7256 280.053 50.6516 277.231 52.9406C274.272 55.3406 273.64 57.9876 275.388 60.6556C276.736 62.7126 277.73 63.0166 283.161 63.0296C286.586 63.0376 290.513 63.6136 291.888 64.3086C295.041 65.9036 297.255 70.4166 296.452 73.6136C295.79 76.2526 292.52 80.0146 290.888 80.0146C289.201 80.0146 289.777 77.4256 291.888 75.5146C292.988 74.5196 293.888 72.8746 293.888 71.8596C293.888 67.9186 290.361 66.0146 283.062 66.0146C277.273 66.0146 275.918 65.6726 274.136 63.7646Z",
    fill: "url(#paint2_linear_81_5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.888 48.7366C305.203 51.9996 300.613 62.7616 304.265 71.2966C307.677 79.2726 319.123 84.6806 324.883 81.0386C326.166 80.2276 326.095 79.8766 324.383 78.5616C323.286 77.7186 321.263 76.7426 319.888 76.3936C312.394 74.4876 308.114 68.9546 309.289 62.6916C310.583 55.7926 319.739 51.7206 325.487 55.4876C328.02 57.1476 328.211 57.1366 330.13 55.2176C331.27 54.0776 331.811 52.6986 331.387 52.0136C329.503 48.9656 318.675 46.9376 313.888 48.7366ZM304.888 65.3346C304.888 57.2986 308.528 52.1746 315.802 49.9706C319.387 48.8836 319.895 48.8886 324.102 50.0576C328.003 51.1406 329.393 52.3896 328.43 53.9466C328.096 54.4876 326.708 54.2806 325.121 53.4526C321.378 51.5006 317.98 51.6616 314.192 53.9706C309.834 56.6276 307.615 60.3326 307.615 64.9516C307.615 69.7766 310.706 74.3256 315.112 75.9836C316.914 76.6616 319.48 77.7336 320.815 78.3656C323.234 79.5106 323.232 79.5156 320.03 79.8306C312.431 80.5786 304.888 73.3576 304.888 65.3346Z",
    fill: "url(#paint3_linear_81_5)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.888 48.5496C336.888 48.8446 337.615 50.1946 338.503 51.5496C339.955 53.7656 340.798 54.0146 346.848 54.0146C354.061 54.0146 356.888 55.5996 356.888 59.6436C356.888 62.6166 354.905 64.0146 350.688 64.0146C348.598 64.0146 346.888 64.4056 346.888 64.8836C346.888 65.3616 348.961 69.4116 351.495 73.8836C355.841 81.5556 356.293 82.0146 359.495 82.0146C361.361 82.0146 362.888 81.8096 362.888 81.5586C362.888 81.3076 361.513 78.7716 359.833 75.9216C356.951 71.0336 356.568 68.0146 358.831 68.0146C360.489 68.0146 362.888 62.3686 362.888 58.4646C362.888 55.6466 362.113 54.0396 359.488 51.4146C356.094 48.0206 356.072 48.0146 346.488 48.0146C341.208 48.0146 336.888 48.2556 336.888 48.5496ZM347.4 52.0146C343.049 52.0146 340.752 51.5556 339.888 50.5146C338.803 49.2066 339.496 49.0146 345.298 49.0146C356.506 49.0146 361.088 52.1676 361.088 59.8796C361.088 62.7586 360.382 64.1206 357.65 66.5086L354.211 69.5146L356.971 74.0146C360.183 79.2526 360.378 80.0146 358.506 80.0146C357.746 80.0146 355.31 76.9766 353.092 73.2646L349.06 66.5146L351.95 66.2026C355.784 65.7896 359.206 61.4706 358.402 58.0576C357.368 53.6696 354.356 52.0146 347.4 52.0146Z",
    fill: "url(#paint4_linear_81_5)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.523 78.0876C369.074 79.2266 367.888 80.5766 367.888 81.0876C367.888 81.6036 372.988 82.0146 379.388 82.0146H390.888V79.0146V76.0146H382.023C374.568 76.0146 372.738 76.3446 370.523 78.0876ZM380.266 80.0146C372.715 80.0146 371.798 79.8286 372.888 78.5146C373.789 77.4296 376.173 77.0146 381.51 77.0146C387.402 77.0146 388.888 77.3166 388.888 78.5146C388.888 79.7316 387.263 80.0146 380.266 80.0146Z",
    fill: "url(#paint5_linear_81_5)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.888 65.0476V68.0806L379.138 67.7976L390.388 67.5146L390.704 64.7646L391.021 62.0146H379.454H367.888V65.0476ZM378.888 66.0146C370.666 66.0146 368.888 65.7476 368.888 64.5146C368.888 63.2816 370.666 63.0146 378.888 63.0146C387.11 63.0146 388.888 63.2816 388.888 64.5146C388.888 65.7476 387.11 66.0146 378.888 66.0146Z",
    fill: "url(#paint6_linear_81_5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.388 51.0146C373.156 53.9036 373.588 54.0146 382.075 54.0146H390.888V51.0146V48.0146H379.201H367.514L370.388 51.0146ZM381.01 52.0146C375.228 52.0146 372.802 51.6156 371.888 50.5146C370.797 49.1996 371.77 49.0146 379.766 49.0146C387.208 49.0146 388.888 49.2906 388.888 50.5146C388.888 51.7206 387.346 52.0146 381.01 52.0146Z",
    fill: "url(#paint7_linear_81_5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.774 51.0306C400.955 53.8346 401.663 54.0146 409.524 54.0146H417.888V51.0146V48.0146L406.138 48.0306L394.388 48.0466L397.774 51.0306ZM408.51 52.0146C403.173 52.0146 400.789 51.5996 399.888 50.5146C398.798 49.2006 399.715 49.0146 407.266 49.0146C414.263 49.0146 415.888 49.2976 415.888 50.5146C415.888 51.7126 414.402 52.0146 408.51 52.0146Z",
    fill: "url(#paint8_linear_81_5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.888 65.0146V68.0146H406.388H417.888V65.0146V62.0146H406.388H394.888V65.0146ZM406.388 66.0146C398.61 66.0146 396.888 65.7426 396.888 64.5146C396.888 63.2866 398.61 63.0146 406.388 63.0146C414.166 63.0146 415.888 63.2866 415.888 64.5146C415.888 65.7426 414.166 66.0146 406.388 66.0146Z",
    fill: "url(#paint9_linear_81_5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.388 79.0146L394.514 82.0146H406.201H417.888V79.0146V76.0146H409.075C400.588 76.0146 400.156 76.1256 397.388 79.0146ZM407.266 80.0146C399.715 80.0146 398.798 79.8286 399.888 78.5146C400.789 77.4296 403.173 77.0146 408.51 77.0146C414.402 77.0146 415.888 77.3166 415.888 78.5146C415.888 79.7316 414.263 80.0146 407.266 80.0146Z",
    fill: "url(#paint10_linear_81_5)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.903 51.7646C421.912 53.8276 422.249 55.9646 422.653 56.5146C423.057 57.0646 427.888 61.5366 433.388 66.4526C438.888 71.3686 445.076 76.9726 447.138 78.9056L450.888 82.4206V65.2176V48.0146H447.924H444.96L444.674 57.5856L444.388 67.1566L433.696 57.5856C427.815 52.3216 422.752 48.0146 422.446 48.0146C422.139 48.0146 421.895 49.7026 421.903 51.7646ZM445.469 69.7676C445.641 69.5946 445.862 64.8546 445.958 59.2336C446.095 51.3086 446.444 49.0146 447.511 49.0146C448.617 49.0146 448.888 51.8846 448.888 63.6176V78.2206L442.138 72.2176C425.171 57.1266 423.668 55.5606 424.032 53.3486C424.341 51.4666 425.751 52.4226 434.772 60.6316C440.483 65.8286 445.296 69.9396 445.469 69.7676Z",
    fill: "url(#paint11_linear_81_5)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.388 51.0146C461.13 53.8766 461.644 54.0146 469.575 54.0146H477.888V51.0146V48.0146H466.701H455.514L458.388 51.0146ZM469.01 52.0146C463.228 52.0146 460.802 51.6156 459.888 50.5146C458.797 49.1996 459.77 49.0146 467.766 49.0146C475.208 49.0146 476.888 49.2906 476.888 50.5146C476.888 51.7206 475.346 52.0146 469.01 52.0146Z",
    fill: "url(#paint12_linear_81_5)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.072 64.7646L455.388 67.5146L466.638 67.7976L477.888 68.0806V65.0476V62.0146H466.322H454.755L455.072 64.7646ZM466.888 66.0146C458.666 66.0146 456.888 65.7476 456.888 64.5146C456.888 63.2816 458.666 63.0146 466.888 63.0146C475.11 63.0146 476.888 63.2816 476.888 64.5146C476.888 65.7476 475.11 66.0146 466.888 66.0146Z",
    fill: "url(#paint13_linear_81_5)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.523 78.0876C457.074 79.2266 455.888 80.5766 455.888 81.0876C455.888 81.6006 460.795 82.0146 466.888 82.0146H477.888V79.0146V76.0146H469.523C462.574 76.0146 460.712 76.3656 458.523 78.0876ZM467.766 80.0146C459.77 80.0146 458.797 79.8296 459.888 78.5146C460.802 77.4136 463.228 77.0146 469.01 77.0146C475.346 77.0146 476.888 77.3086 476.888 78.5146C476.888 79.7386 475.208 80.0146 467.766 80.0146Z",
    fill: "url(#paint14_linear_81_5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.654 51.0436C488.147 53.3116 489.878 54.0146 492.97 54.0146C500.475 54.0146 504.83 57.9436 504.866 64.7486C504.883 68.0046 504.233 69.7156 502.056 72.1526C499.667 74.8266 498.349 75.3946 493.63 75.7856C489.038 76.1666 487.531 76.7866 485.212 79.2476L482.388 82.2446L490.965 81.8176C501.141 81.3116 505.251 79.2726 508.792 72.9716C513.424 64.7306 509.658 52.9056 501.288 49.4086C499.377 48.6096 494.629 48.0276 490.17 48.0436L482.388 48.0736L485.654 51.0436ZM491.799 52.0146C489.634 52.0146 487.58 51.3486 486.784 50.3886C485.555 48.9086 486.068 48.7986 492.522 49.1636C498.42 49.4966 500.237 50.0436 503.354 52.4216C510.234 57.6686 511.777 67.1486 506.872 74.0366C503.945 78.1476 499.393 80.0146 492.298 80.0146C487.607 80.0146 486.838 79.7796 487.787 78.6366C488.416 77.8786 491.471 77.0476 494.577 76.7906C499.343 76.3956 500.662 75.8316 503.035 73.1766C506.754 69.0136 507.512 65.5506 505.793 60.5786C504.682 57.3646 503.455 56.0446 499.926 54.2646C497.472 53.0266 493.815 52.0146 491.799 52.0146Z",
    fill: "url(#paint15_linear_81_5)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.888 115.515V124.015H221.388C227.842 124.015 228.836 122.271 222.638 121.822C218.835 121.547 218.355 121.226 218.072 118.765C217.767 116.12 217.93 116.015 222.322 116.015C224.833 116.015 226.888 115.565 226.888 115.015C226.888 114.465 224.863 114.015 222.388 114.015C218.255 114.015 217.888 113.811 217.888 111.515C217.888 109.219 218.255 109.015 222.388 109.015C224.863 109.015 226.888 108.565 226.888 108.015C226.888 107.465 224.413 107.015 221.388 107.015H215.888V115.515Z",
    fill: "url(#paint16_linear_81_5)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.888 107.698C230.888 110.231 236.837 123.515 237.972 123.515C238.719 123.515 240.735 119.85 242.547 115.201C245.194 108.41 245.491 106.945 244.17 107.201C243.204 107.389 241.782 109.829 240.638 113.265C239.584 116.428 238.419 119.015 238.048 119.015C237.678 119.015 236.456 116.458 235.332 113.332C234.208 110.206 232.748 107.468 232.088 107.248C231.428 107.028 230.888 107.231 230.888 107.698Z",
    fill: "url(#paint17_linear_81_5)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.539 106.771C253.965 107.7 247.888 123.206 247.888 123.742C247.888 124.777 250.788 123.719 251.25 122.515C252.08 120.35 258.815 120.532 260.446 122.763C263.06 126.338 263.021 122.902 260.368 115.822C257.511 108.198 255.544 105.144 254.539 106.771ZM253.394 116.265C253.791 115.303 254.356 113.672 254.65 112.642C255.14 110.93 255.299 110.973 256.501 113.142C258.486 116.721 258.162 118.015 255.281 118.015C253.19 118.015 252.817 117.668 253.394 116.265Z",
    fill: "url(#paint18_linear_81_5)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M266.597 106.639C265.197 108.039 265.932 109.015 268.388 109.015C270.832 109.015 270.888 109.182 270.888 116.515C270.888 122.515 271.188 124.015 272.388 124.015C273.588 124.015 273.888 122.515 273.888 116.515V109.015H276.971C278.991 109.015 279.912 108.584 279.642 107.765C279.193 106.404 267.814 105.422 266.597 106.639Z",
    fill: "url(#paint19_linear_81_5)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M283.598 106.638C282.197 108.039 282.932 109.015 285.388 109.015C287.774 109.015 287.888 109.286 287.888 114.945C287.888 120.267 287.665 120.909 285.716 121.195C284.522 121.371 283.359 122.078 283.133 122.765C282.831 123.681 284.502 124.015 289.388 124.015C294.274 124.015 295.945 123.681 295.643 122.765C295.417 122.078 294.254 121.371 293.06 121.195C291.111 120.909 290.888 120.267 290.888 114.945C290.888 109.235 290.984 109.015 293.471 109.015C295.091 109.015 295.901 108.549 295.642 107.765C295.194 106.406 284.802 105.434 283.598 106.638Z",
    fill: "url(#paint20_linear_81_5)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M299.888 115.015C299.888 122.211 300.179 124.015 301.338 124.015C302.402 124.015 302.868 122.484 303.088 118.265L303.388 112.515L306.711 118.265C311.593 126.711 312.888 126.012 312.888 114.932C312.888 108.112 312.576 105.951 311.638 106.26C310.921 106.495 310.175 109.076 309.888 112.311L309.388 117.951L305.94 111.983C301.025 103.476 299.888 104.046 299.888 115.015Z",
    fill: "url(#paint21_linear_81_5)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.388 106.938C319.145 108.451 316.385 112.448 317.398 117.061C319.409 126.215 333.888 126.174 333.888 117.015C333.888 114.182 333.666 114.015 329.888 114.015C326.999 114.015 325.888 114.432 325.888 115.515C325.888 116.448 326.832 117.015 328.388 117.015C329.763 117.015 330.888 117.455 330.888 117.992C330.888 118.529 329.763 119.706 328.388 120.607C326.078 122.121 325.7 122.122 323.404 120.617C316.782 116.279 321.733 106.186 328.663 109.895C330.544 110.901 331.888 110.506 331.888 108.946C331.888 107.744 326.549 106.315 324.388 106.938Z",
    fill: "url(#paint22_linear_81_5)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M355.262 106.779C349.05 107.781 346.378 116.714 350.862 121.488C353.625 124.428 359.832 124.992 361.908 122.491C363.65 120.392 362.675 119.765 359.527 120.962C355.685 122.423 352.216 120.786 351.414 117.134C350.195 111.582 354.976 107.386 359.663 109.895C361.544 110.901 362.888 110.506 362.888 108.946C362.888 107.856 357.709 106.384 355.262 106.779Z",
    fill: "url(#paint23_linear_81_5)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.547 106.758C372.261 107.22 370.917 110.504 369.56 114.056C368.202 117.609 366.773 121.303 366.383 122.265C365.895 123.469 366.142 124.015 367.174 124.015C367.999 124.015 368.933 123.34 369.25 122.515C370.08 120.35 376.815 120.532 378.446 122.763C381.07 126.352 381.037 122.868 378.379 115.579C375.702 108.239 373.598 105.057 372.547 106.758ZM373.59 118.015C371.175 118.015 371.118 117.876 372.157 114.49C373.326 110.681 374.354 110.925 375.426 115.265C376.031 117.716 375.831 118.015 373.59 118.015Z",
    fill: "url(#paint24_linear_81_5)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.555 106.682C385.188 107.048 384.888 111.098 384.888 115.682C384.888 122.422 385.175 124.015 386.388 124.015C387.388 124.015 387.888 123.015 387.888 121.015C387.888 118.695 388.335 118.015 389.862 118.015C391.045 118.015 392.459 119.219 393.388 121.015C394.91 123.959 396.888 125.052 396.888 122.949C396.888 122.363 396.425 121.018 395.858 119.959C395.088 118.521 395.243 117.404 396.469 115.532C398.627 112.238 397.611 108.24 394.295 106.98C391.374 105.869 386.532 105.704 385.555 106.682ZM391.388 115.015C388.166 115.015 387.888 114.777 387.888 112.015C387.888 109.724 388.342 109.015 389.806 109.015C393.242 109.015 394.888 110.183 394.888 112.622C394.888 114.69 394.413 115.015 391.388 115.015Z",
    fill: "url(#paint25_linear_81_5)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M401.888 115.515V124.015H407.388C413.842 124.015 414.836 122.271 408.638 121.822C404.835 121.547 404.355 121.226 404.072 118.765C403.767 116.12 403.93 116.015 408.322 116.015C410.833 116.015 412.888 115.565 412.888 115.015C412.888 114.465 410.863 114.015 408.388 114.015C404.255 114.015 403.888 113.811 403.888 111.515C403.888 109.219 404.255 109.015 408.388 109.015C410.863 109.015 412.888 108.565 412.888 108.015C412.888 107.465 410.413 107.015 407.388 107.015H401.888V115.515Z",
    fill: "url(#paint26_linear_81_5)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M417.888 115.515V124.015H423.388C426.413 124.015 428.888 123.565 428.888 123.015C428.888 122.465 426.863 122.015 424.388 122.015C420.055 122.015 419.888 121.904 419.888 119.015C419.888 116.182 420.11 116.015 423.888 116.015C426.088 116.015 427.888 115.565 427.888 115.015C427.888 114.465 426.088 114.015 423.888 114.015C420.288 114.015 419.888 113.765 419.888 111.515C419.888 109.219 420.255 109.015 424.388 109.015C426.863 109.015 428.888 108.565 428.888 108.015C428.888 107.465 426.413 107.015 423.388 107.015H417.888V115.515Z",
    fill: "url(#paint27_linear_81_5)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.098 115.185C433.291 120.614 433.807 123.493 434.638 123.768C435.457 124.039 435.888 123.119 435.888 121.098C435.888 118.518 436.276 118.015 438.267 118.015C439.967 118.015 441 118.871 441.888 121.015C442.571 122.665 443.763 124.015 444.535 124.015C445.699 124.015 445.666 123.486 444.341 120.924C442.887 118.112 442.885 117.676 444.315 116.095C446.18 114.035 446.376 109.903 444.688 108.215C444.028 107.555 441.085 107.015 438.148 107.015H432.807L433.098 115.185ZM439.281 115.015C436.178 115.015 435.888 114.759 435.888 112.015C435.888 109.377 436.235 109.015 438.766 109.015C442.096 109.015 444.198 111.043 443.298 113.388C442.891 114.448 441.492 115.015 439.281 115.015Z",
    fill: "#EBE394"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.408 50.3016C183.163 56.1046 182.077 69.7046 191.218 77.7306C197.614 83.3476 206.448 83.0676 213.182 77.0366L216.388 74.1646L213.647 73.1176C211.411 72.2636 210.253 72.4566 207.355 74.1666C197.472 79.9976 187.02 69.3946 192.398 58.9946C193.229 57.3886 194.774 55.6106 195.833 55.0446C198.633 53.5456 205.114 53.7846 207.528 55.4756C209.421 56.8016 209.816 56.7206 211.813 54.5946L214.012 52.2536L209.634 50.1336C203.991 47.4016 198.426 47.4596 193.408 50.3016ZM185.888 64.7636C185.888 58.9136 189.829 52.9436 195.388 50.3716C199.106 48.6516 205.987 49.1946 209.48 51.4836C213.225 53.9366 211.182 55.2266 206.246 53.5256C197.814 50.6206 189.888 55.9996 189.888 64.6266C189.888 67.0836 190.628 70.2146 191.536 71.6006C194.845 76.6506 202.638 78.5156 207.888 75.5146C209.263 74.7286 211.278 74.0696 212.365 74.0496C214.153 74.0176 214.086 74.2716 211.66 76.6976C207.852 80.5046 198.572 81.2186 193.515 78.0926C189.739 75.7596 185.888 69.0286 185.888 64.7636Z",
    fill: "#EBE394"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.888 65.0146C201.888 67.8456 202.112 68.0146 205.872 68.0146C208.891 68.0146 210.648 67.2946 213.122 65.0436L216.388 62.0736L209.138 62.0436L201.888 62.0146V65.0146ZM206.766 66.0146C203.986 66.0146 202.888 65.5896 202.888 64.5146C202.888 63.3766 204.124 63.0146 208.01 63.0146C212.45 63.0146 212.967 63.2146 211.888 64.5146C211.173 65.3756 208.992 66.0146 206.766 66.0146Z",
    fill: "#EBE394"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.422 51.0506C226.271 54.0236 226.506 54.0806 234.859 53.8006C243.34 53.5166 243.39 53.4986 243.704 50.7646L244.021 48.0146H232.267H220.514L223.422 51.0506ZM234.01 52.0146C228.228 52.0146 225.802 51.6156 224.888 50.5146C223.797 49.1996 224.77 49.0146 232.766 49.0146C240.208 49.0146 241.888 49.2906 241.888 50.5146C241.888 51.7206 240.346 52.0146 234.01 52.0146Z",
    fill: "#EBE394"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.888 115.515V124.015H206.388C209.413 124.015 211.888 123.565 211.888 123.015C211.888 122.465 209.863 122.015 207.388 122.015H202.888V114.515C202.888 110.182 202.466 107.015 201.888 107.015C201.3 107.015 200.888 110.515 200.888 115.515Z",
    fill: "url(#paint28_linear_81_5)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184.888 115.515V124.015H190.388C196.842 124.015 197.836 122.271 191.638 121.822C187.835 121.547 187.355 121.226 187.072 118.765C186.772 116.164 186.975 116.015 190.822 116.015C193.058 116.015 194.888 115.565 194.888 115.015C194.888 114.465 193.088 114.015 190.888 114.015C187.288 114.015 186.888 113.765 186.888 111.515C186.888 109.219 187.255 109.015 191.388 109.015C193.863 109.015 195.888 108.565 195.888 108.015C195.888 107.465 193.413 107.015 190.388 107.015H184.888V115.515Z",
    fill: "url(#paint29_linear_81_5)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M195.388 50.3716C189.829 52.9436 185.888 58.9136 185.888 64.7636C185.888 69.0286 189.739 75.7596 193.515 78.0926C198.572 81.2186 207.852 80.5046 211.66 76.6976C214.086 74.2716 214.153 74.0176 212.365 74.0496C211.278 74.0696 209.263 74.7286 207.888 75.5146C202.638 78.5156 194.845 76.6506 191.536 71.6006C190.628 70.2146 189.888 67.0836 189.888 64.6266C189.888 55.9996 197.814 50.6206 206.246 53.5256C211.182 55.2266 213.225 53.9366 209.48 51.4836C205.987 49.1946 199.106 48.6516 195.388 50.3716Z",
    fill: "#EBE394"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M249.888 64.5146C249.888 77.6256 250.119 80.0146 251.388 80.0146C252.65 80.0146 252.888 77.7926 252.888 66.0146V52.0146H258.388C262.61 52.0146 263.888 51.6666 263.888 50.5146C263.888 49.3246 262.444 49.0146 256.888 49.0146H249.888V64.5146Z",
    fill: "#EBE394"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M275.908 50.3136C270.693 52.9216 269.868 59.1916 274.136 63.7646C275.918 65.6726 277.273 66.0146 283.062 66.0146C290.361 66.0146 293.888 67.9186 293.888 71.8596C293.888 72.8746 292.988 74.5196 291.888 75.5146C289.777 77.4256 289.201 80.0146 290.888 80.0146C292.52 80.0146 295.79 76.2526 296.452 73.6136C297.255 70.4166 295.041 65.9036 291.888 64.3086C290.513 63.6136 286.586 63.0376 283.161 63.0296C277.73 63.0166 276.736 62.7126 275.388 60.6556C273.64 57.9876 274.272 55.3406 277.231 52.9406C280.053 50.6516 279.083 48.7256 275.908 50.3136Z",
    fill: "#EBE394"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M315.802 49.9706C308.528 52.1746 304.888 57.2986 304.888 65.3346C304.888 73.3576 312.431 80.5786 320.03 79.8306C323.232 79.5156 323.234 79.5106 320.815 78.3656C319.48 77.7336 316.914 76.6616 315.112 75.9836C310.706 74.3256 307.615 69.7766 307.615 64.9516C307.615 60.3326 309.834 56.6276 314.192 53.9706C317.98 51.6616 321.378 51.5006 325.121 53.4526C326.708 54.2806 328.096 54.4876 328.43 53.9466C329.393 52.3896 328.003 51.1406 324.102 50.0576C319.895 48.8886 319.387 48.8836 315.802 49.9706Z",
    fill: "#EBE394"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M202.888 64.5146C202.888 65.5896 203.986 66.0146 206.766 66.0146C208.992 66.0146 211.173 65.3756 211.888 64.5146C212.967 63.2146 212.45 63.0146 208.01 63.0146C204.124 63.0146 202.888 63.3766 202.888 64.5146Z",
    fill: "#EBE394"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M224.888 50.5146C225.802 51.6156 228.228 52.0146 234.01 52.0146C240.346 52.0146 241.888 51.7206 241.888 50.5146C241.888 49.2906 240.208 49.0146 232.766 49.0146C224.77 49.0146 223.797 49.1996 224.888 50.5146Z",
    fill: "#EBE394"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M221.888 64.5146C221.888 65.7476 223.666 66.0146 231.888 66.0146C240.11 66.0146 241.888 65.7476 241.888 64.5146C241.888 63.2816 240.11 63.0146 231.888 63.0146C223.666 63.0146 221.888 63.2816 221.888 64.5146Z",
    fill: "#EBE394"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M225.329 78.4826C223.577 79.8086 224.286 79.9536 232.638 79.9826C240.208 80.0086 241.888 79.7426 241.888 78.5146C241.888 76.4046 228.112 76.3776 225.329 78.4826Z",
    fill: "#EBE394"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M339.888 50.5146C340.752 51.5556 343.049 52.0146 347.4 52.0146C354.356 52.0146 357.368 53.6696 358.402 58.0576C359.206 61.4706 355.784 65.7896 351.95 66.2026L349.06 66.5146L353.092 73.2646C355.31 76.9766 357.746 80.0146 358.506 80.0146C360.378 80.0146 360.183 79.2526 356.971 74.0146L354.211 69.5146L357.65 66.5086C360.382 64.1206 361.088 62.7586 361.088 59.8796C361.088 52.1676 356.506 49.0146 345.298 49.0146C339.496 49.0146 338.803 49.2066 339.888 50.5146Z",
    fill: "#EBE394"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M371.888 50.5146C372.802 51.6156 375.228 52.0146 381.01 52.0146C387.346 52.0146 388.888 51.7206 388.888 50.5146C388.888 49.2906 387.208 49.0146 379.766 49.0146C371.77 49.0146 370.797 49.1996 371.888 50.5146Z",
    fill: "#EBE394"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M368.888 64.5146C368.888 65.7476 370.666 66.0146 378.888 66.0146C387.11 66.0146 388.888 65.7476 388.888 64.5146C388.888 63.2816 387.11 63.0146 378.888 63.0146C370.666 63.0146 368.888 63.2816 368.888 64.5146Z",
    fill: "#EBE394"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M372.888 78.5146C371.798 79.8286 372.715 80.0146 380.266 80.0146C387.263 80.0146 388.888 79.7316 388.888 78.5146C388.888 77.3166 387.402 77.0146 381.51 77.0146C376.173 77.0146 373.789 77.4296 372.888 78.5146Z",
    fill: "#EBE394"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M399.888 78.5146C398.798 79.8286 399.715 80.0146 407.266 80.0146C414.263 80.0146 415.888 79.7316 415.888 78.5146C415.888 77.3166 414.402 77.0146 408.51 77.0146C403.173 77.0146 400.789 77.4296 399.888 78.5146Z",
    fill: "#EBE394"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M396.888 64.5146C396.888 65.7426 398.61 66.0146 406.388 66.0146C414.166 66.0146 415.888 65.7426 415.888 64.5146C415.888 63.2866 414.166 63.0146 406.388 63.0146C398.61 63.0146 396.888 63.2866 396.888 64.5146Z",
    fill: "#EBE394"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M399.888 50.5146C400.789 51.5996 403.173 52.0146 408.51 52.0146C414.402 52.0146 415.888 51.7126 415.888 50.5146C415.888 49.2976 414.263 49.0146 407.266 49.0146C399.715 49.0146 398.798 49.2006 399.888 50.5146Z",
    fill: "#EBE394"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M445.958 59.2336C445.862 64.8546 445.641 69.5946 445.469 69.7676C445.296 69.9396 440.483 65.8286 434.772 60.6316C425.751 52.4226 424.341 51.4666 424.032 53.3486C423.668 55.5606 425.171 57.1266 442.138 72.2176L448.888 78.2206V63.6176C448.888 51.8846 448.617 49.0146 447.511 49.0146C446.444 49.0146 446.095 51.3086 445.958 59.2336Z",
    fill: "#EBE394"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M456.888 64.5146C456.888 65.7476 458.666 66.0146 466.888 66.0146C475.11 66.0146 476.888 65.7476 476.888 64.5146C476.888 63.2816 475.11 63.0146 466.888 63.0146C458.666 63.0146 456.888 63.2816 456.888 64.5146Z",
    fill: "#EBE394"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M459.888 50.5146C460.802 51.6156 463.228 52.0146 469.01 52.0146C475.346 52.0146 476.888 51.7206 476.888 50.5146C476.888 49.2906 475.208 49.0146 467.766 49.0146C459.77 49.0146 458.797 49.1996 459.888 50.5146Z",
    fill: "#EBE394"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M459.888 78.5146C458.797 79.8296 459.77 80.0146 467.766 80.0146C475.208 80.0146 476.888 79.7386 476.888 78.5146C476.888 77.3086 475.346 77.0146 469.01 77.0146C463.228 77.0146 460.802 77.4136 459.888 78.5146Z",
    fill: "#EBE394"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M486.784 50.3886C487.58 51.3486 489.634 52.0146 491.799 52.0146C493.815 52.0146 497.472 53.0266 499.926 54.2646C503.455 56.0446 504.682 57.3646 505.793 60.5786C507.512 65.5506 506.754 69.0136 503.035 73.1766C500.662 75.8316 499.343 76.3956 494.577 76.7906C491.471 77.0476 488.416 77.8786 487.787 78.6366C486.838 79.7796 487.607 80.0146 492.298 80.0146C499.393 80.0146 503.945 78.1476 506.872 74.0366C511.777 67.1486 510.234 57.6686 503.354 52.4216C500.237 50.0436 498.42 49.4966 492.522 49.1636C486.068 48.7986 485.555 48.9086 486.784 50.3886Z",
    fill: "#EBE394"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_81_5",
    x1: 254.078,
    y1: 80.6461,
    x2: 346.211,
    y2: 111.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#C8C19B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_81_5",
    x1: 279.898,
    y1: 48,
    x2: 279.898,
    y2: 124.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#D9C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE394"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogogetscreened);
export default __webpack_public_path__ + "static/media/logogetscreened.8c2c871b81e0f9335c5212bcc5eb4399.svg";
export { ForwardRef as ReactComponent };